"use client";
import Link from "next/link";
import type { Route } from "next";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useEventRuntime } from "./event-runtime";

export function EventOperationNotices() {
  const runtime = useEventRuntime();
  const t = useTranslations("events");
  if (
    !runtime.storageReady ||
    (runtime.storageAvailable &&
      !runtime.records.length &&
      !runtime.terminals.length)
  )
    return null;
  return (
    <aside
      data-slot="event-operation-notices"
      data-debug-source="src/components/events/event-operation-notices.tsx"
      className="space-y-3 border-b border-warning-border bg-warning-soft p-4 text-sm text-warning-foreground"
    >
      {!runtime.storageAvailable ? (
        <div role="alert" className="flex flex-wrap items-center gap-3">
          <p>{t("feedback.storage")}</p>
          <Button variant="outline" onClick={runtime.restore}>
            {t("retry")}
          </Button>
        </div>
      ) : null}
      {runtime.records.map((record) => (
        <div
          key={record.idempotencyKey}
          role="status"
          className="flex min-w-0 flex-wrap items-center gap-3"
        >
          <p className="min-w-0 flex-1">{t("recovery.unknown")}</p>
          <Button
            variant="outline"
            disabled={runtime.pending}
            onClick={() => void runtime.lookup(record)}
          >
            {t("recovery.lookup")}
          </Button>
          <Button asChild variant="outline">
            <Link
              href={
                (record.operationType.startsWith("opening.")
                  ? `/openings/${record.eventId}/${record.revisionId}`
                  : record.operationType === "qualification.record"
                    ? `/qualifications/${record.eventId}/${record.revisionId}/${record.stageCode}`
                    : `${runtime.binding.audience === "supplier" ? "/supplier/events" : "/sourcing"}/${record.eventId}`) as Route
              }
            >
              {t("recovery.view")}
            </Link>
          </Button>
        </div>
      ))}
      {runtime.lookupFailed ? (
        <p role="alert">{t("recovery.lookupFailed")}</p>
      ) : null}
      {runtime.terminals.map((item) => (
        <div
          key={item.idempotencyKey}
          role="status"
          className="flex flex-wrap items-center gap-3"
        >
          <p className="min-w-0 flex-1">
            {t(
              item.terminalState === "Completed"
                ? "recovery.completed"
                : "recovery.failed",
            )}
          </p>
          <Button
            variant="outline"
            onClick={() => runtime.dismiss(item.idempotencyKey)}
          >
            {t("recovery.dismiss")}
          </Button>
        </div>
      ))}
    </aside>
  );
}
